import { render, staticRenderFns } from "./SendReportTaskModal.vue?vue&type=template&id=70b9412c&"
import script from "./SendReportTaskModal.vue?vue&type=script&lang=js&"
export * from "./SendReportTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./SendReportTaskModal.vue?vue&type=style&index=0&id=70b9412c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports